import {EntitySpecialPurpose} from '../backend/enums/entity-special-purpose';
import {RolePermissionType} from '../backend/enums/role-permission-type';
import {useAuth} from '../contexts/auth/context';

/**
 * Entity settings are still under development, so they are only available to users that can read
 * them in entities used for testing purposes.
 */
export const useCanViewEntitySettings = (): boolean => {
  const {state, hasReadPermission} = useAuth();

  return (
    hasReadPermission(RolePermissionType.Settings_Entity_Settings) &&
    state.session?.selectedAffiliation?.entity.specialPurpose === EntitySpecialPurpose.Testing
  );
};
